import { useEffect, useState } from "react";
import { Phone, ArrowUpRight } from "@phosphor-icons/react";

export default function StickyMobileCTA() {
  const [hidden, setHidden] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onMenu = (e) => setMenuOpen(Boolean(e.detail));
    window.addEventListener("webjesters:menu", onMenu);
    return () => window.removeEventListener("webjesters:menu", onMenu);
  }, []);

  // Hidden over the hero (it has its own CTAs) and while contact/footer are on screen.
  useEffect(() => {
    const targets = [document.getElementById("top"), document.getElementById("contact"), document.querySelector('[data-testid="site-footer"]')].filter(Boolean);
    const visible = new Set();
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => (e.isIntersecting ? visible.add(e.target) : visible.delete(e.target)));
        setHidden(visible.size > 0);
      },
      { threshold: 0.12 }
    );
    targets.forEach((t) => io.observe(t));
    return () => io.disconnect();
  }, []);

  return (
    <div
      data-testid="sticky-mobile-cta"
      aria-hidden={hidden || menuOpen}
      className={`md:hidden fixed bottom-4 left-4 right-4 z-40 flex gap-2.5 drop-shadow-[0_-4px_14px_rgba(0,0,0,0.28)] transition-opacity duration-300 ${
        hidden || menuOpen ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
    >
      <a
        href="tel:6023905623"
        data-testid="sticky-call"
        className="flex-1 py-3 inline-flex items-center justify-center gap-2 rounded-full border border-white/15 glass text-white text-[13.5px] font-medium"
      >
        <Phone size={15} weight="regular" />
        Call Now
      </a>
      <a
        href="#contact"
        data-testid="sticky-quote"
        className="flex-1 py-3 inline-flex items-center justify-center gap-2 rounded-full bg-white text-black text-[13.5px] font-medium"
      >
        Get a quote
        <ArrowUpRight size={14} weight="bold" />
      </a>
    </div>
  );
}
